import React from "react";
import { Switch, Route } from "react-router-dom";

import ItemTransactionsPage from "./ItemTransactionsPage";
import ItemTransactionPage from "./ItemTransactionPage";

const ItemTransactionsRouter = () => (
  <Switch>
    <Route path="/inventory/item-transactions/:id/details/:BatchNo">
      <ItemTransactionPage />
    </Route>
    <Route path="/inventory/item-transactions">
      <ItemTransactionsPage />
    </Route>
  </Switch>
);

export default ItemTransactionsRouter;
